import { useState } from "react";
import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import { useSiteContent } from "../context/SiteContentContext";
import FadeIn from "../components/ui/FadeIn";
import TiltCard from "../components/ui/TiltCard";
import RainbowDivider from "../components/ui/RainbowDivider";

const WHATSAPP_NUMBER = "923390002106";

const FreeResources = () => {
  const { content } = useSiteContent();
  const ct = content.contact;
  const whatsappNumber = (ct?.whatsappLink || `https://wa.me/${WHATSAPP_NUMBER}`).replace(/\D/g, "").slice(-12) || WHATSAPP_NUMBER;
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [designation, setDesignation] = useState("");
  const [source, setSource] = useState("");
  const [triedIncomplete, setTriedIncomplete] = useState(false);

  const isComplete = name.trim() && phone.trim() && designation && source;

  const waLink = () => {
    const text = `Assalamu Alaikum! I'd love to be notified when new free videos/worksheets are added to the Free Resources page.\nName: ${name.trim()}\nPhone: ${phone.trim()}\nEmail: ${email.trim() || "(not provided)"}\nI am a: ${designation}\nFound you via: ${source}`;
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
  };

  const handleSend = () => {
    if (!isComplete) { setTriedIncomplete(true); return; }
    window.open(waLink(), "_blank", "noopener,noreferrer");
  };

  return (
    <div style={{ paddingTop: 72 }}>
      {/* ── Hero ── */}
      <section style={{ background:`linear-gradient(160deg,${C.mint} 0%,#2d8f75 100%)`, padding:"100px 6vw 90px", position:"relative", overflow:"hidden", minHeight:"46vh", display:"flex", alignItems:"center" }}>
        <div style={{ position:"absolute", top:-80, right:-80, width:400, height:400, borderRadius:"50%", background:"rgba(255,255,255,0.08)", pointerEvents:"none" }}/>
        <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.2)", color:C.white, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>Free, No Enrolment Needed</div>
          <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(28px,5vw,52px)", color:C.white, lineHeight:1.1, margin:"0 0 18px", maxWidth:640 }}>
            Free Resources.
          </h1>
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(14px,2vw,18px)", color:"rgba(255,255,255,0.88)", maxWidth:600, lineHeight:1.8, margin:0 }}>
            Short videos and printable worksheets, open to every family — whether or not you're enrolled with us. Our free library and it's growing.
          </p>
        </div>
      </section>

      {/* ── Content types ── */}
      <section style={{ background:C.cream, padding:"90px 6vw" }}>
        <div style={{ maxWidth:1000, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:48 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>What's Here</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,40px)", color:C.navy, margin:0 }}>Videos & Printables.</h2>
              <RainbowDivider />
            </div>
          </FadeIn>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:22 }}>
            <FadeIn>
              <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:22, padding:"30px 26px", border:`2px solid ${C.coral}22`, boxShadow:"0 4px 16px rgba(0,0,0,0.05)" }}>
                <div style={{ fontSize:34, marginBottom:14 }}>🎥</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:19, color:C.coral, marginBottom:10 }}>Free Videos</div>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, margin:0 }}>
                  Short teaching moments — a du'a, a Tajweed tip, a conscious-parenting idea — the kind of thing our teachers and mothers share in the classroom, made public.
                </p>
              </TiltCard>
            </FadeIn>
            <FadeIn delay={0.08}>
              <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:22, padding:"30px 26px", border:`2px solid ${C.mint}22`, boxShadow:"0 4px 16px rgba(0,0,0,0.05)" }}>
                <div style={{ fontSize:34, marginBottom:14 }}>📄</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:19, color:C.mint, marginBottom:10 }}>Free Worksheets</div>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, margin:0 }}>
                  A taste of the kind of hands-on, print-and-go activity sheets we use daily — free to download and try at home.
                </p>
              </TiltCard>
            </FadeIn>
          </div>
          <FadeIn delay={0.15}>
            <div style={{
              marginTop:32, background:`${C.yellow}18`, border:`2px dashed ${C.yellow}60`,
              borderRadius:20, padding:"26px 28px", textAlign:"center",
            }}>
              <p style={{ fontFamily:"Nunito", fontSize:13.5, color:"#7a5c00", lineHeight:1.8, margin:0 }}>
                We're adding to this library regularly. Nothing here yet feels like "enough" to us either — check back soon, or leave your details below and we'll let you know the moment something new drops.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── Notify me ── */}
      <section style={{ background:C.warmGray, padding:"90px 6vw" }}>
        <div style={{ maxWidth:560, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ background:C.white, borderRadius:24, padding:"40px 36px", boxShadow:"0 8px 32px rgba(0,0,0,0.07)", textAlign:"center" }}>
              <div style={{ fontSize:40, marginBottom:14 }}>🔔</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:22, color:C.navy, margin:"0 0 8px" }}>Get Notified of New Free Resources</h2>
              <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.muted, lineHeight:1.7, margin:"0 0 24px" }}>
                Fill in your details and send — it opens WhatsApp with your message pre-filled so nothing gets lost.
              </p>

              <input
                type="text" placeholder="Your Full Name *" value={name} onChange={e=>setName(e.target.value)}
                style={{
                  width:"100%", padding:"12px 15px", border:`2px solid ${C.navy}18`, borderRadius:12,
                  fontFamily:"Nunito", fontSize:14, color:C.text, background:C.white, outline:"none",
                  boxSizing:"border-box", marginBottom:12,
                }}
              />
              <input
                type="tel" placeholder="Your Phone / WhatsApp Number *" value={phone} onChange={e=>setPhone(e.target.value)}
                style={{
                  width:"100%", padding:"12px 15px", border:`2px solid ${C.navy}18`, borderRadius:12,
                  fontFamily:"Nunito", fontSize:14, color:C.text, background:C.white, outline:"none",
                  boxSizing:"border-box", marginBottom:12,
                }}
              />
              <input
                type="email" placeholder="Your Email (optional)" value={email} onChange={e=>setEmail(e.target.value)}
                style={{
                  width:"100%", padding:"12px 15px", border:`2px solid ${C.navy}18`, borderRadius:12,
                  fontFamily:"Nunito", fontSize:14, color:C.text, background:C.white, outline:"none",
                  boxSizing:"border-box", marginBottom:16,
                }}
              />

              <div style={{ textAlign:"left", marginBottom:16 }}>
                <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.navy, marginBottom:8 }}>I am a... *</div>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {["Mother","Teacher","Other"].map(val => (
                    <button key={val} type="button" onClick={()=>setDesignation(val)} style={{
                      background: designation === val ? C.navy : C.white,
                      color: designation === val ? C.white : C.navy,
                      border:`2px solid ${C.navy}`, fontFamily:"Nunito", fontWeight:700, fontSize:12.5,
                      padding:"7px 14px", borderRadius:100, cursor:"pointer", transition:"all 0.2s",
                    }}>{val}</button>
                  ))}
                </div>
              </div>

              <div style={{ textAlign:"left", marginBottom:20 }}>
                <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.navy, marginBottom:8 }}>Where did you find us? *</div>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {["Facebook","Instagram","Google","Other"].map(val => (
                    <button key={val} type="button" onClick={()=>setSource(val)} style={{
                      background: source === val ? C.navy : C.white,
                      color: source === val ? C.white : C.navy,
                      border:`2px solid ${C.navy}`, fontFamily:"Nunito", fontWeight:700, fontSize:12.5,
                      padding:"7px 14px", borderRadius:100, cursor:"pointer", transition:"all 0.2s",
                    }}>{val}</button>
                  ))}
                </div>
              </div>

              <button type="button" onClick={handleSend} style={{
                display:"block", width:"100%", background: isComplete ? "#25D366" : `${C.navy}30`,
                color: isComplete ? C.white : C.navy, border:"none",
                fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"15px", borderRadius:100, cursor:"pointer",
              }}>🔔 Notify Me via WhatsApp</button>
              {triedIncomplete && !isComplete && (
                <p style={{ fontFamily:"Nunito", fontSize:12, color:C.coral, marginTop:10 }}>
                  Please fill in your name, phone number, designation, and how you found us.
                </p>
              )}
            </div>
          </FadeIn>
        </div>
      </section>

      <section style={{ background:C.cream, padding:"0 6vw 70px" }}>
        <div style={{ maxWidth:560, margin:"0 auto", textAlign:"center", display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap" }}>
          <Link to="/resources" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Looking for our paid resources instead? →</Link>
          <Link to="/upcoming" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>See our upcoming courses →</Link>
        </div>
      </section>
    </div>
  );
};

export default FreeResources;
